module.exports = __webpack_public_path__ + "img/down-white.6fb70b83.jpg";